import axios from 'axios'
import { CommonVirtualShelfEnumResponse } from '@/api/services/common/virtual-shelf/common-virtual-shelf.dto'

class CommonVirtualShelfService {
    async getVirtualShelfs(): Promise<CommonVirtualShelfEnumResponse[]> {
        const response = await axios.get<CommonVirtualShelfEnumResponse[]>(`/common/virtualShelf`)
        return response.data
    }
}

export const commonVirtualShelfService = new CommonVirtualShelfService()
